import { render, staticRenderFns } from "./FastNewCustomer.vue?vue&type=template&id=b0cd5064&"
import script from "./FastNewCustomer.vue?vue&type=script&lang=js&"
export * from "./FastNewCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports